export interface ShipperConsigneeDetails {
  first_name: string;
  last_name: string;
  name: string;
  account_number: number;
  phone: string;
  email: string;
  fax: string;
  address: Address;
  eori?: string;
}

interface CodeName {
  code: string;
  name: string;
}

export interface Address {
  place: string;
  line1: string;
  line2: string;
  city: CodeName;
  postal_code: string;
  state_province: string;
  country: CodeName;
}

export interface AgentDetails {
  account_number: string;
  iata: string;
  cass: string;
  name: string;
  place: string;
}

export interface ExecutionDetails {
  date: string;
  place: string;
  shipper_signature: string;
  carrier_signature: string;
}

export interface HandlingInformation {
  shc: string;
  other_info: string;
  shc_id: string[];
  sci: string;
}

export interface ChargesDeclarationDetails {
  currency_code: string;
  charge_code: string;
  weight_or_valuation: string;
  other: string;
  values_for_carriage: number;
  values_for_custom: number;
  values_for_insurance: number;
}

interface ValueWithUOM {
  value: string;
  uom: string;
}

interface ULD {
  number: string;
}

interface Dimension {
  pcs: number;
  length: number;
  width: number;
  height: number;
  uom: string;
  weight: number;
}

export interface RateInformationDetails {
  number_of_pieces: number;
  gross_weight: ValueWithUOM;
  volume: ValueWithUOM;
  slac: number;
  rate_class_code: string;
  rate_or_charge: number;
  commodity_item_number: number;
  chargeable_weight: number;
  charge_amount: number;
  nature_and_quantity_of_goods: string;
  uld?: ULD[];
  dims?: Dimension[];
  hsc?: number[];
}

export enum EAwbType {
  SHIPPER = 'SHIPPER',
  CONSIGNEE = 'CONSIGNEE',
  AGENT = 'AGENT',
  NOTIFY = 'NOTIFY',
  REFERENCE = 'REFERENCE',
  ROUTING = 'ROUTING',
  EXECUTION = 'EXECUTION',
  CHARGES = 'CHARGES',
  RATES = 'RATES',
  HOUSEAWB = 'HOUSEAWB',
  OCI = 'OCI',
  HANDLING = 'HANDLING',
}

export interface IEawbDetails {
  id?: number;
  reference: string;
  type: EAwbType;
  details: string;
  isSubmitted?: boolean;
}

export interface EawbDetailsWithError {
  errorMessage: string;
  quoteEAwbList: IEawbDetails[];
}

export interface IFhlDetails {
  id?: number;
  reference: string;
  type: string;
  details: string;
}
